import { DeviceTypesProvider } from 'core/contexts/device-types';
import { SettingsDevicesConfigurationLayoutContainer } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/workflow/settings-devices-configuration-layout.container';

export const SettingsDevicesConfigurationLayoutScene = () => (
    <DeviceTypesProvider>
        <SettingsDevicesConfigurationLayoutContainer />
    </DeviceTypesProvider>
);

export default SettingsDevicesConfigurationLayoutScene;
